import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Members from "@/components/Members";
import Tour from "@/components/Tour";
import Gallery from "@/components/Gallery";
import Listen from "@/components/Listen";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function Landing() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Members />
        <Tour />
        <Gallery />
        <Listen />
        <Contact />
      </main>
      <Footer />
      <Toaster position="top-center" richColors theme="dark" />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
